import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Grid, Avatar, Typography, Button, Icon, Hidden } from "@material-ui/core";
import Parser from "html-react-parser";

import { client } from "../../config/apollo";
import {
  parentContainer,
  webFont,
  textBlack,
  primaryColor,
  textGrey,
  fontColor
} from "../../config/theme";
import Header from "../Header";
import Footer from "../Footer/FooterLoggedIn";
import { GET_POST } from "../../graphql/queries/posts";
import { FAV, LIKE_POST, UNFAV } from "../../graphql/mutations/user";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { compose, graphql } from "react-apollo";
import { GET_SAVED_DISHES, GET_SAVED_POSTS } from "../../graphql/queries/user";
import Breadcrumbs from "../Breadcrumbs";
const defaultChefImg = "/images/orange-logo-white-bg.webp";

class PostDetail extends Component {
  state = {
    postId: null,
    post: {},
    liked: false,
    favourite: false,
    likedCount: 0,
    fromScreen: '',
    savedPosts: []
  };

  getDetails = () => {
    const { location } = this.props;
    if (!!location.state) {
      const { postId } = location.state;
      this.setState({ postId }, () => { this.getSavedPosts(); });
      client
        .query({
          query: GET_POST,
          variables: {
            id: postId
          },
          fetchPolicy: 'network-only'
        })
        .then(postDetails => {
          if (postDetails.data) {
            this.setState({
              post: postDetails.data.post,
              likedCount: postDetails.data.post.numOfLikes,
              liked: postDetails.data.post.liked
            });
          }
        })
        .catch(err => {});
    }
  };

  getSavedPosts = () => {
    client
      .query({
        query: GET_SAVED_POSTS,
        variables: {
          userId: this.props.userId
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        if (response.data && response.data.savedPosts && response.data.savedPosts.posts && response.data.savedPosts.posts.length) {
          this.setState({ savedPosts: response.data.savedPosts.posts });
          const sData = response.data.savedPosts.posts;
          console.log('SDATA LEN: ', sData);
          if (sData.length) {
            const index = sData.findIndex(item => item.id === this.state.postId);
            this.setState({favourite: index > -1});
          }
        } else {
          this.setState({favourite: false});
        }
      })
      .catch(err =>  console.error('ERR Fetching Saved post data', err));
  };

  componentDidMount() {
    const { location } = this.props;
    if (!!location.state) {
      this.getDetails();
      const { screen } = location.state;
      if (screen) {
        this.setState({ fromScreen: screen })
      }
    } else {
      this.props.history.push("/home/dashboard");
    }
  }

  favourite = postId => {
    const { userId } = this.props;
    const { savedPosts } = this.state;
    let isFav = false;

    if (savedPosts.length) {
      const index = savedPosts.findIndex(item => item.id === postId);
      isFav = index > -1;
    }

    if (isFav) {
      client
        .mutate({
          mutation: UNFAV,
          variables: {
            userId,
            itemsToDelete: { posts: [postId] }
          }
        })
        .then(() => {
          this.getSavedPosts();
        })
        .catch(err => console.error(err));
    } else {
      client
        .mutate({
          mutation: FAV,
          variables: {
            userId,
            itemsToAdd: { posts: [postId] }
          }
        })
        .then(() => {
          this.getSavedPosts();
        })
        .catch(err => {
          console.error(err);
        });
    }
  };

  like = postId => {
    const { userId } = this.props;
    client
      .mutate({
        mutation: LIKE_POST,
        variables: {
          userId,
          postId,
        }
      })
      .then(() => {
        const count = this.state.liked ? this.state.likedCount - 1 : this.state.likedCount + 1;
        this.setState({ liked: !this.state.liked, likedCount: count });
      })
      .catch(err => console.error(err));
  };

  render() {
    const { post } = this.state;
    let postImg = null;
    if (post.media) {
      if (post.media.length > 0) {
        const length = post.media.length;
        const index = post.media.findIndex(item => item.size === "MEDIUM");
        if (index < 0) {
          postImg = post.media[length - 1].url;
        } else {
          postImg = post.media[index].url;
        }
      }
    }

    let childRoutes = [
      {
        display: 'Post Details',
        link: 'home/post-details'
      },
    ];

    if (this.state.fromScreen === 'saved') {
      childRoutes = [{
        display: 'Saved',
        link: 'home/saved'
      },{
        display: 'Post Details',
        link: 'home/post-details'
      }];
    } if (this.state.fromScreen === 'post-search') {
      childRoutes = [{
        display: 'Posts',
        link: 'home/post-search'
      },{
        display: 'Post Details',
        link: 'home/post-details'
      }];
    }
    if (this.props.viewAsDiner) {
      childRoutes = [{
        display: 'View As Diner',
        link: '#'
      }, {
        display: 'Post Details',
        link: 'home/post-details'
      }];
    }

    return (
      <div style={parentContainer}>
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: 60 }}>
            <Header history={this.props.history} />
          </Grid>

          <Grid className="saved-item-container ipad-width" container direction="row">
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <Breadcrumbs childRoutes={childRoutes} />
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row">
                <Grid data-test-id={"postdet-chefimg"} item xs={3} sm={3} md={3} lg={2}>
                  <Hidden smDown>
                    <Avatar
                      src={post.profilePic ? post.profilePic : defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImg}
                    />
                  </Hidden>
                  <Hidden mdUp>
                    <Avatar
                      src={post.profilePic ? post.profilePic : defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImgiPad}
                    />
                  </Hidden>
                </Grid>

                <Grid item xs={6} sm={5} md={6} lg={8} style={{ paddingTop: 10, paddingLeft: 20 }}>
                  <Typography
                    data-test-id={"postdet-name"}
                    variant="h5"
                    style={{ ...style.setFont }}
                    gutterBottom={false}
                  >
                    {post.chefName}
                    {console.log('POST FAVOURITE: ', this.state.favourite)}
                    {this.state.favourite && !this.props.viewAsDiner && (
                      <IconButton onClick={() => this.favourite(post.id)}>
                        <Icon data-test-id={"postdet-favourite"} style={{ color: "#ff8000" }} >favorite</Icon>
                      </IconButton>
                    )}
                    {!this.state.favourite && !this.props.viewAsDiner && (
                      <IconButton onClick={() => this.favourite(post.id)}>
                        <Icon data-test-id={"postdet-favourite"} >favorite_border</Icon>
                      </IconButton>
                    )}
                  </Typography>
                  <Typography
                    data-test-id={"postdet-date"}
                    variant="body1"
                    style={{
                      ...style.setFont,
                      ...style.setFontGrey
                    }}
                    gutterBottom={true}
                  >
                    On {moment(Number(post.createdAt)).format("DD MMM YYYY")}
                  </Typography>
                  <Typography
                    data-test-id={"postdet-tags"}
                    variant="body2"
                    style={{
                      ...style.setFont,
                      ...style.setFontGrey,
                      marginTop: 20
                    }}
                    gutterBottom={true}
                  >
                    {!!post.tags ? post.tags.toString().replace(/,/g, ", ") : ""}
                  </Typography>
                </Grid>
                <Hidden xsDown>
                  <Grid data-test-id={"postdet-fav"} md={3} sm={4} lg={2}>
                    <Grid container style={{textAlign: 'right', paddingTop: 10}}>
                      <Grid item md={6} sm={4} style={{ paddingTop: 13, marginRight: -20 }}>
                        {this.state.likedCount <= 0 ? 0 : this.state.likedCount} like(s)
                      </Grid>
                      <Grid item md={6} sm={8} style={{marginLeft: 10}}>
                        {!this.props.viewAsDiner && <IconButton onClick={() => this.like(post.id)}>
                          {post.liked ? (<Icon>thumb_up</Icon>) : (<Icon>thumb_up_outline</Icon>)}
                        </IconButton>}
                      </Grid>
                    </Grid>
                  </Grid>
                </Hidden>
              </Grid>
              <Grid container style={{ marginTop: 63 }}>
                <Grid data-test-id={"postdet-title"} item xs={12}>
                  <Typography
                    variant="h4"
                    style={style.setFont}
                    gutterBottom={true}
                  >
                    {post.title}
                  </Typography>

                  {postImg && (
                    <Grid style={{ marginTop: 43 }}>
                      <img
                        data-test-id={"postdet-img"}
                        src={postImg}
                        style={{
                          width: "100%",
                          minHeight: 400,
                          maxHeight: 650,
                          objectFit: "cover",
                          marginBottom: 30,
                          borderRadius: 5,
                        }}
                      />
                    </Grid>
                  )}

                  <div style={style.setFont}>
                    {post.body ? Parser(post.body) : ""}
                  </div>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 60 }} />
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </div>
    );
  }
}
const PostDetailsWithData = compose(
  graphql(GET_SAVED_POSTS, {
    name: "savedPosts",
    options: props => ({
      variables: {
        userId: props.userId
      },
      fetchPolicy: "network-only"
    })
  })
)(PostDetail);
const mapPropsToState = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    viewAsDiner: state.user.viewAsDiner,
  };
};

const PostDetails = connect(mapPropsToState)(PostDetailsWithData);

export default PostDetails;

const style = {
  avatarImg: {
    width: 180,
    height: 180,
    borderRadius: 90
  },
  avatarImgiPad: {
    width: 150,
    height: 150,
    borderRadius: 75
  },
  setFont: {
    fontFamily: webFont
  },
  setFontGrey: {
    color: textGrey
  },
  btnDishTypeSelected: {
    borderRadius: "50%",
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    color: fontColor,
    backgroundColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10
  },
  dishTypeDet: {
    fontSize: 10
  }
};
